export const osnTop108SIcon = {
  data: `<svg viewBox="0 0 280 210" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M9.8
150.56C9.8 185.56 45.64 202.36 84.84 202.36C124.04 202.36 159.88 185.28 159.88 150.56C159.88 127.88 141.96 110.52
119.56 102.68C140.28 95.68 156.8 81.9599 156.8 58.7199C156.8 23.7199 119.28 9.43994 84.84 9.43994C50.12 9.43994
12.88 23.7199 12.88 58.7199C12.88 81.9599 29.12 95.68 49.84 102.68C27.44 110.52 9.8 127.88 9.8 150.56ZM116.2
64.8799C116.2 79.4399 96.32 85.8799 84.84 87.5599C73.36 85.8799 53.2 79.4399 53.2 64.8799C53.2 51.7199 66.36 43.6
84.84 43.6C103.04 43.6 116.2 51.7199 116.2 64.8799ZM119.56 145.8C119.56 159.52 103.88 168.2 84.84 168.2C65.24 168.2
50.12 159.52 50.12 145.8C50.12 129.56 73.08 121.72 84.84 120.32C96.32 121.72 119.56 129.56 119.56 145.8Z" fill="#0F0125"
 stroke="currentColor" stroke-width="13"/></svg>`,
  name: 'top-10-8-s',
};
